// extracted by mini-css-extract-plugin
export default {"Tooltip":"SchedulePost_Tooltip__YJ4jB","TooltipRadio":"SchedulePost_TooltipRadio__f9to7"};